import React from "react";

import "./styles.scss"
import ChatHistoryMain from "../../esg-chat/chat-history";

const RealEstateHistory = () => {
    return (
        <>
            <ChatHistoryMain model="RealEstate" searchBy="Public" />
        </>
    )
}

export default RealEstateHistory